import React, { useState } from 'react'
import TabDraftBroadcastEmail from '../Email/BroadcastEmail/table/TabDraftBroadcastEmail'
import TabUnreadNotification from './TabUnreadNotification'
import TabReadNotification from './TabReadNotification'
import { DateRangePicker } from 'rsuite'
import { useDataTableStore } from '../../stores/DataTableStore'
import useCheckIsMobile from '../../hooks/useCheckIsMobile'
import useCalendarLocale from '../../hooks/CalendarLocale'
import usePredefinedRanges from '../../hooks/PredefinedRanges'
import { endOfMonth, startOfMonth } from 'date-fns'
import useNotificationStore from '../../stores/Notification'
import { useIntl } from 'react-intl'

const MasterNotification = () => {
  const [displayMode, setDisplayMode] = useState<'READ' | 'UNREAD'>('UNREAD');
  const { isLoadingTable } = useDataTableStore()
  const { isMobile } = useCheckIsMobile()
  const calendarLocale = useCalendarLocale();
  const predefinedRanges = usePredefinedRanges();
  const { startDate, endDate, setStartDate, setEndDate } = useNotificationStore()
  const intl = useIntl()

  return (
    <>
      <div className="row justify-content-end mb-3">
        <div className="col-lg-8 col-sm-9 col-xl-7">
          <div className="d-flex float-end px-3">
            <DateRangePicker
              style={{ width: "250px" }}
              cleanable={false}
              character=" - "
              format="dd MMM yyyy"
              locale={calendarLocale}
              value={[startDate, endDate]}
              ranges={predefinedRanges}
              placement="bottomEnd"
              onChange={(value) => {
                if (value && value.length === 2) {
                  setStartDate(value[0]);
                  setEndDate(value[1]);
                }
              }}
              showOneCalendar={isMobile}
              disabled={isLoadingTable[displayMode === 'UNREAD' ? 'unreadNotification' : 'readNotification']}
              isoWeek={true}
              editable={false}
            />
          </div>
        </div>
      </div>

      <div className='card'>
        <div className="card-header border-0">
          <div className="card-title pt-3 mb-0 gap-4 gap-lg-10 gap-xl-10 nav nav-tabs border-bottom-0">
            <div className={`fs-4 fw-bolder pb-3 cursor-pointer ${displayMode === 'UNREAD' ? 'border-bottom border-3 border-primary' : 'text-muted'}`} onClick={() => setDisplayMode('UNREAD')}>{intl.formatMessage({ id: 'NOTIFICATION.LABEL.UNREAD' })}</div>
            <div className={`fs-4 fw-bolder pb-3 cursor-pointer ${displayMode === 'READ' ? 'border-bottom border-3 border-primary' : 'text-muted'}`} onClick={() => setDisplayMode('READ')}>{intl.formatMessage({ id: 'NOTIFICATION.LABEL.READ' })}</div>
          </div>
        </div>
        <div className={`${displayMode === 'UNREAD' ? 'd-block' : 'd-none'}`}>
          <TabUnreadNotification />
        </div>

        <div className={`${displayMode === 'READ' ? 'd-block' : 'd-none'}`}>
          <TabReadNotification />
        </div>

      </div>
    </>
  )
}

export default MasterNotification